var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuToggle = function SvgMenuToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2.5h1.6A1.2 1.2 0 0 1 4 1.7v1.6a1.2 1.2 0 0 1-1.2 1.2H1.2A1.2 1.2 0 0 1 0 3.3V1.7A1.2 1.2 0 0 1 1.2.5Zm0 1a.2.2 0 0 0-.2.2v1.6c0 .11.09.2.2.2h1.6a.2.2 0 0 0 .2-.2V1.7a.2.2 0 0 0-.2-.2H1.2ZM7 2a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H7Zm0 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H7ZM2.8 6.5H1.2A1.2 1.2 0 0 0 0 7.7v1.6a1.2 1.2 0 0 0 1.2 1.2h1.6A1.2 1.2 0 0 0 4 9.3V7.7a1.2 1.2 0 0 0-1.2-1.2ZM1 7.7c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H1.2a.2.2 0 0 1-.2-.2V7.7Z",
    fill: "currentColor"
  })));
};
export default SvgMenuToggle;